module.exports = "<p>\n  cover works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/mainpage/cover/cover.component.html
// module id = ./src/mainpage/cover/cover.component.html
// module chunks = main